import { useTranslation } from "react-i18next";
import { translate as tr } from "../../i18n";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {useSelector} from "react-redux";
import Loader from "../common/loader";

export default function InviteReject () {
  useTranslation();
    const history = useNavigate();
    const auth = useSelector(state=>state.auth);
    const [state, setState] = useState(false);

    useEffect(() => {
        if (auth.loading) {
            return;
        }
        if(auth.isAuthenticated === true) {
            history("/dashboard");
            return;
        }
        checkUser();
    },[auth.loading, auth.isAuthenticated, history]);

    const  checkUser = async () => {
        try {
        let url_string = window.location.href;
        var url = new URL(url_string);
        var c = url.searchParams.get("id");
        if(c) {
            let text = atob(c);
            let data = text.split(' ');
            let email = data[1];
            let invite_id = data[0];

            const config = {
                headers: {
                  "Content-Type": "application/json",
                },
            };

            const body = JSON.stringify({ invite_id, email });
            let res = await axios.put("/api/invitation/reject", body, config );
            if(res.status === 200) {
                if(res.data.msg === 'success') {
                    setState(true);
                }
            }
        }
        else {
            history("/");
        }
      }
      catch (err) {
          console.log(err)
      }
    }

    return (
        <div style={{position: "fixed",
        top: "50%",
        left: "50%",
        /* bring your own prefixes */
        transform: "translate(-50%, -50%)",display:"flex"}}>
            {
            state===true?
                <div>
                    <h2>{tr("You have Rejected the Invitation...!")} </h2>
                    <a href="https://minutezilla.com/" >{tr("click here to Start Tracking Time.")} </a>
                </div>
                :
                <Loader />
            }
        </div>
    )
}
